/* eslint-disable camelcase */
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Logo from "../images/footer-logo.svg";
import { appUrl } from "../../../constants/url-constants";
import { InView } from "react-intersection-observer";

const MarketingFooter = ({ showBottomNavbar, footerRef }) => {

    const handleInView = (inView) => {
        footerRef.current = inView;
    };

    return (
        <React.Fragment>
            <InView as="span" onChange={(inView) => handleInView(inView)} />
            <footer styleName={`styles.footerTag ${showBottomNavbar ? "styles.bottomNavbarFooter" : ""}`}>
                <div className={"container"}>
                    <div className={"row"}>
                        <div styleName={"styles.wrapper"} className={"col-sm-12 text-center"}>
                            <img src={Logo} alt="logo" />
                            <div className={"row d-none d-sm-block "} styleName={"styles.copyright"}>
                                <span >
                                &#174; 2019 www.cars24.com
                                </span>
                                <span className={"text-right"}>
                                All rights reserved
                                </span>
                            </div>
                            <div className={"row"}>
                                <ul styleName={"styles.footerLink"}>
                                    <span>
                                        <li>
                                            <a href={`${appUrl()}/about-us/`}
                                                className="topTittleContent">
                                            About Us
                                            </a>
                                        </li>
                                        <li>
                                            <a href={`${appUrl()}/need-help/`}
                                                className="topTittleContent">
                                            24x7 Support
                                            </a>
                                        </li>
                                    </span>
                                    <li>
                                        <a href={`${appUrl()}/privacy-policy/`}
                                            className="topTittleContent">
                                        Privacy Policy
                                        </a>
                                    </li>
                                    <li>
                                        <a href={`${appUrl()}/terms-and-conditions/`}
                                            className="topTittleContent">
                                        Terms & Conditions
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className={"row d-block d-sm-none"} styleName={"styles.copyright"}>
                                <span>&#174; 2019 www.cars24.com</span>
                                <span className="float-right">All rights reserved</span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </React.Fragment>
    );
};

MarketingFooter.propTypes = {
    showBottomNavbar: PropTypes.bool,
    footerRef: PropTypes.any
};

export default MarketingFooter;
